import React from 'react';
import styled from 'styled-components';

const LeftLineCard = ({
  style,
  className,
  children,
  innerStyle
}) => {
  return (
    <CardWrapper style={style} className={className}>
      <LeftBorderLine />
      <CardInner style={innerStyle}>
        {children}
      </CardInner>
    </CardWrapper>
  );
};

const CardWrapper = styled.div`
  display: flex;
  box-shadow: 2px 1px #EEEEEE;
  border: 1px solid #E8E8E8;
  border-radius: 8px;
  background-color: #FFFFFF;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
`;

const LeftBorderLine = styled.div`
  align-self: stretch;
  width: 6px;
  min-width: 6px;
  max-width: 6px;
  background-color: #94ACF9;
`;

const CardInner = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 8px;
`;

export { LeftLineCard };
